// Slug → URL map of the bundled hero images used by the legacy hand-coded guide
// pages. Lets the admin UI show the "current" hero for guides that don't yet
// have a DB override in `guides.hero_image_url`.

import beachCampingHero from "@/assets/beach-camping-hero.jpg";
import bigSurfGuideHero from "@/assets/big-surf-guide-hero.jpg";
import mopBeachHero from "@/assets/mission-ocean-pacific-beach-hero.jpg";
import bestBeachesHero from "@/assets/guides/best-beaches-hero.jpg";
import bonfireHero from "@/assets/guides/bonfire-beaches-hero.jpg";
import sdTidePoolsHero from "@/assets/san-diego-tide-pools-hero.jpg";
import bestSurfHero from "@/assets/best-surf-spots-hero.jpg";
import coastalBirdingHero from "@/assets/coastal-birding-trails-hero.jpg";
import coastalFitnessHero from "@/assets/coastal-fitness-hero.jpg";
import lagoonsHero from "@/assets/lagoons/hero.jpg";
import coasterHero from "@/assets/coaster-beach-hop-hero.jpg";
import dogBeachesHero from "@/assets/guides/dog-beaches-hero.jpg";
import firstTimeHero from "@/assets/first-time-beaches-hero.jpg";
import kitesurfHero from "@/assets/kitesurf-windsports-hero.jpg";
import laJollaSeaLionsHero from "@/assets/la-jolla-cove-sea-lions.jpg";
import laJollaSnorkelingHero from "@/assets/guides/la-jolla-snorkeling-hero.jpg";
import laJollaTidePoolsHero from "@/assets/la-jolla-tide-pools-hero.jpg";
import missionBoardwalkHero from "@/assets/guides/mission-beach-boardwalk-hero.jpg";
import coastalBikingHero from "@/assets/guides/coastal-biking-san-diego-hero.jpg";
import northCountyWaterHero from "@/assets/north-county-water-sports-hero.jpg";
import parkingHero from "@/assets/parking-without-pain-hero.jpg";
import postSurfEatsHero from "@/assets/post-surf-eats-hero.jpg";
import beachParkingHero from "@/assets/san-diego-beach-parking-hero.jpg";
import bioluminescenceHero from "@/assets/guides/bioluminescence-hero.jpg";
import kidsHero from "@/assets/san-diego-with-kids-hero.jpg";
import thingsToDoLaJollaHero from "@/assets/guides/things-to-do-la-jolla-hero.jpg";
import thingsToDoPacificBeachHero from "@/assets/guides/things-to-do-pacific-beach-hero.jpg";
import thingsToDoMissionBeachHero from "@/assets/guides/things-to-do-mission-beach-hero.jpg";
import thingsToDoOceanBeachHero from "@/assets/guides/things-to-do-ocean-beach-hero.jpg";
import balboaParkMuseumsHero from "@/assets/guides/balboa-park-museums-hero.jpg";
import sanDiegoSeaCavesHero from "@/assets/guides/san-diego-sea-caves-hero.jpg";
import missionBayHero from "@/assets/guides/mission-bay-san-diego-hero.jpg";
import sunsetCliffsTidePoolsHero from "@/assets/guides/sunset-cliffs-tide-pools-hero.jpg";
import oceansideHero from "@/assets/guides/oceanside-hero.jpg";
import oceanBeachDogHero from "@/assets/guides/ocean-beach-dog-beach-hero.jpg";
import tidePoolingHero from "@/assets/tide-pooling-guide-hero.jpg";
import tideCalendarHero from "@/assets/guides/tide-calendar-hero.jpg";
import whaleHero from "@/assets/whale-watching-sunset-cliffs-1024.jpg";
import whereToEatHero from "@/assets/where-to-eat-hero.jpg";

export const LEGACY_GUIDE_HEROES: Record<string, string> = {
  "balboa-park-museums": balboaParkMuseumsHero,
  "beach-camping-san-diego": beachCampingHero,
  "san-diego-big-surf-guide": bigSurfGuideHero,
  "mission-beach-vs-ocean-beach-vs-pacific-beach": mopBeachHero,
  "best-beaches-in-san-diego": bestBeachesHero,
  "best-beaches-for-birding": coastalBirdingHero,
  "best-beaches-for-sunset": bestBeachesHero,
  "best-beaches-for-toddlers": kidsHero,
  "best-bonfire-beaches-san-diego": bonfireHero,
  "best-san-diego-tide-pools": sdTidePoolsHero,
  "best-surf-spots-by-skill-level": bestSurfHero,
  "central-san-diego-beaches-guide": missionBoardwalkHero,
  "coastal-birding-trails": coastalBirdingHero,
  "coastal-fitness-san-diego": coastalFitnessHero,
  "coastal-lagoons": lagoonsHero,
  "coaster-beach-hop": coasterHero,
  "dog-friendly-beaches-san-diego": dogBeachesHero,
  "ocean-beach-dog-beach-guide": oceanBeachDogHero,
  "first-time-san-diego-beaches": firstTimeHero,
  "kitesurf-windsports-guide": kitesurfHero,
  "la-jolla-cove-sea-lion-viewing-guide": laJollaSeaLionsHero,
  "la-jolla-cove-snorkeling": laJollaSnorkelingHero,
  "la-jolla-tide-pools-guide": laJollaTidePoolsHero,
  "mission-beach-boardwalk": missionBoardwalkHero,
  "coastal-biking-san-diego": coastalBikingHero,
  "north-county-beaches-guide": oceansideHero,
  "north-county-water-sports": northCountyWaterHero,
  "parking-without-pain": parkingHero,
  "post-surf-eats": postSurfEatsHero,
  "san-diego-beach-parking-guide": beachParkingHero,
  "san-diego-beach-parking-map": beachParkingHero,
  "san-diego-bioluminescence": bioluminescenceHero,
  "san-diego-tide-calendar": tideCalendarHero,
  "san-diego-with-kids": kidsHero,
  "south-bay-beaches-guide": bestBeachesHero,
  "things-to-do-in-la-jolla": thingsToDoLaJollaHero,
  "things-to-do-in-mission-beach": thingsToDoMissionBeachHero,
  "things-to-do-in-ocean-beach": thingsToDoOceanBeachHero,
  "things-to-do-in-pacific-beach": thingsToDoPacificBeachHero,
  "san-diego-sea-caves": sanDiegoSeaCavesHero,
  "mission-bay-san-diego": missionBayHero,
  "sunset-cliffs-tide-pools": sunsetCliffsTidePoolsHero,
  "things-to-do-in-oceanside": oceansideHero,
  "tide-pooling-guide": tidePoolingHero,
  "ultimate-tide-pooling-route": tidePoolingHero,
  "whale-watching-san-diego": whaleHero,
  "where-to-eat-san-diego-coast": whereToEatHero,
};

export const getLegacyHero = (slug: string): string | undefined => LEGACY_GUIDE_HEROES[slug];
